import type { ErrorCopy } from '@shared/errors/catalog';

import { contentAndAssetsErrors } from '../_shared/errors';

/**
 * The codes this surface meets — the content catalogue for the title and its
 * credits, the assets catalogue for the cover replacement.
 *
 * The provider failures matter most on this route as well, and for the same
 * reason: a re-fetch that could not reach the provider changes nothing, and the
 * copy says the scores are unchanged rather than implying the title is.
 */
export const errors: Readonly<Record<string, ErrorCopy>> = contentAndAssetsErrors;
